import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const SafetyIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="25.354" height="30.425" viewBox="0 0 25.354 30.425" {...props}>
    <path
      id="Union_13"
      data-name="Union 13"
      d="M585.623-6279.535c-.5-.22-12.162-5.516-12.162-15.1v-6.486a6.33,6.33,0,0,1,4.334-6.013l7.942-2.648a1.264,1.264,0,0,1,.8,0l7.943,2.648a6.332,6.332,0,0,1,4.334,6.013v6.486c0,9.588-11.663,14.884-12.163,15.1a1.268,1.268,0,0,1-.515.109A1.268,1.268,0,0,1,585.623-6279.535Zm-7.025-25.2a3.8,3.8,0,0,0-2.6,3.607v6.486c0,6.933,8.008,11.456,10.141,12.537,2.131-1.084,10.141-5.622,10.141-12.537v-6.486a3.8,3.8,0,0,0-2.6-3.607l-7.541-2.515Zm6.413,13.321h-.043a2.374,2.374,0,0,1-1.706-.76l-2.923-3.042a1.273,1.273,0,0,1-.329-1.243,1.269,1.269,0,0,1,.928-.892,1.267,1.267,0,0,1,1.229.377l2.844,2.966,5.31-5.324a1.272,1.272,0,0,1,1.8,0,1.272,1.272,0,0,1,0,1.8l-5.416,5.416a2.367,2.367,0,0,1-1.68.7Z"
      transform="translate(-573.461 6309.851)"
      fill="#3477eb"
    />
  </Svg>
));

SafetyIcon.displayName = 'SafetyIcon';

export default SafetyIcon;
